const initProductGallery = () => {
  const galleries = document.querySelectorAll('[data-product-gallery-mobile]');

  if (galleries.length) {
    galleries.forEach(gallery => {
      const slides = gallery.querySelectorAll('[data-gallery-slide]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      const main = gallery.querySelector('[data-product-gallery-main]');

      if (!slides.length || !thumbs.length || !main) return;

      let currentIndex = 0;
      const maxIndex = slides.length - 1;

      const setActive = targetIndex => {
        currentIndex = Number(targetIndex);

        slides.forEach(slide => {
          const isActive = slide.dataset.gallerySlide === String(targetIndex);
          slide.classList.toggle('hidden', !isActive);
        });

        thumbs.forEach(thumb => {
          const isActive = thumb.dataset.galleryThumb === String(targetIndex);
          thumb.classList.toggle('border-blue', isActive);
          thumb.classList.toggle('border-white', !isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          setActive(thumb.dataset.galleryThumb);
        });
      });

      // Set first thumbnail as active on initial load
      setActive(0);

      // Basic horizontal swipe support on the main image (mobile)
      let startX = 0;
      let isTouching = false;

      main.addEventListener(
        'touchstart',
        event => {
          if (!event.touches || !event.touches.length) return;
          startX = event.touches[0].clientX;
          isTouching = true;
        },
        { passive: true },
      );

      main.addEventListener(
        'touchend',
        event => {
          if (!isTouching || !event.changedTouches || !event.changedTouches.length) return;

          const endX = event.changedTouches[0].clientX;
          const deltaX = endX - startX;
          const threshold = 40;

          if (Math.abs(deltaX) > threshold) {
            let nextIndex = currentIndex;

            if (deltaX < 0 && currentIndex < maxIndex) {
              nextIndex += 1;
            } else if (deltaX > 0 && currentIndex > 0) {
              nextIndex -= 1;
            }

            if (nextIndex !== currentIndex) {
              setActive(nextIndex);
            }
          }

          isTouching = false;
        },
        { passive: true },
      );
    });
  }

  // Desktop zoom on grid images using <dialog>
  const dialog = document.querySelector('[data-pdp-zoom-dialog]');
  const zoomImage = dialog?.querySelector('[data-pdp-zoom-image]');
  const closeButton = dialog?.querySelector('[data-pdp-zoom-close]');
  const triggers = document.querySelectorAll('[data-pdp-zoom-trigger]');

  if (!dialog || !zoomImage || !triggers.length || dialog.dataset.pdpZoomInit === 'true') {
    return;
  }

  dialog.dataset.pdpZoomInit = 'true';

  const openZoom = (src, alt) => {
    zoomImage.src = src;
    zoomImage.alt = alt || '';

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const closeZoom = () => {
    zoomImage.src = '';

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const { pdpZoomSrc, pdpZoomAlt } = trigger.dataset;
      if (!pdpZoomSrc) return;

      openZoom(pdpZoomSrc, pdpZoomAlt);
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeZoom);
  }

  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      closeZoom();
    }
  });

  dialog.addEventListener('cancel', event => {
    event.preventDefault();
    closeZoom();
  });
};

export default initProductGallery;

